import { render, staticRenderFns } from "./PressPostOverview.vue?vue&type=template&id=51569190&scoped=true"
import script from "./PressPostOverview.vue?vue&type=script&lang=js"
export * from "./PressPostOverview.vue?vue&type=script&lang=js"
import style0 from "./PressPostOverview.vue?vue&type=style&index=0&id=51569190&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51569190",
  null
  
)

export default component.exports